/* RESPONSIBLE TEAM: team-proactive-support */

import Model, { attr } from '@ember-data/model';

export default class DomainKey extends Model {
  @attr() declare domainForCustomerDnsRecord: string;
  @attr() declare domainForIntercomDnsRecord: string;
  @attr() declare validRecordExists: boolean;
  @attr() declare state: string;

  get isActive() {
    return this.state === 'active';
  }
}
